import { motion } from 'framer-motion';
import { Phone, ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';

export const CTASection = () => {
  return (
    <section 
      className="py-24 md:py-32 bg-gradient-to-br from-[#001582] to-[#001ea7] relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#FFC107] rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FFC107] rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center justify-center w-20 h-20 bg-[#FFC107] rounded-2xl mb-8"
          >
            <MessageSquare className="w-10 h-10 text-[#001582]" />
          </motion.div>

          {/* Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
          >
            Butuh Solusi <span className="text-[#FFC107]">Engineering</span> dan{' '}
            <span className="text-[#FFC107]">Manufacturing</span> untuk Industri Anda?
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-slate-300 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto"
          >
            Tim kami siap membantu kebutuhan machining, fabrication, dan repair equipment 
            industri Anda dengan standar kualitas tertinggi.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <a 
              href="https://wa.me/6285210005588" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Button 
                size="lg"
                className="bg-[#FFC107] text-[#001582] hover:bg-[#FFD54F] font-bold text-base px-10 py-6 rounded-xl shadow-lg"
                data-testid="cta-contact"
              >
                <MessageSquare className="w-5 h-5 mr-2" />
                Hubungi Kami
              </Button>
            </a>
            <a href="tel:02182609241">
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-white/30 text-white hover:bg-white/10 font-semibold text-base px-10 py-6 rounded-xl"
                data-testid="cta-phone"
              >
                <Phone className="mr-2 w-5 h-5" />
                021-82609241
              </Button>
            </a>
          </motion.div>

          {/* Quick Info */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 pt-10 border-t border-white/10"
          >
            <p className="text-slate-400 text-sm">
              Atau kirim email ke{' '}
              <a 
                href="mailto:admin@imamontaz.id" 
                className="text-[#FFC107] hover:text-[#FFD54F] transition-colors font-medium"
              >
                admin@imamontaz.id
              </a>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
